import React from "react"
import SeminarTypes from "./seminar/seminar-types"
import SeminarStatus from "./seminar/seminar-status"
import { Link, graphql, useStaticQuery } from 'gatsby'
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"

export const SeminarArea = () => {
  const data = useStaticQuery (
    graphql`
    query CanJoinSeminarQuery {
      canJoinSeminars: allMicrocmsSeminars(
        limit: 3
        sort: {fields: [publishedAt], order: DESC}
      ) {
      edges {
        node {
          seminarsId
            title
            image {
              url
            }
            status
            types
            display_event_date
            tags {
              id
              name
              type
            }
          }
        }
      }
    }`
  )

  return (
    <div className="contents_01 component_seminar_cards" id="seminar">
      <div className="contents_in">
        <div className="padding_sp">{/* スマホのみ隙間 */}

          {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
          <div className="title_section">
            <div className="flex_left">
              <h4 className="maintitle">Seminar</h4>
              <p className="subtitle">最新のセミナー</p>
            </div>
            <div className="more"><Link to="/seminar"><span>view more</span></Link></div>
          </div>
          {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}

          <div className="flex_wrap">
            {data.canJoinSeminars.edges.map(({ node }) => (
              <div className="flex_item" key={node.seminarsId}>
                <SeminarStatus status={node.status} />
                <Link to={"/seminar/" + node.seminarsId}>
                  <div className="thumbnail_container">
                    <LazyAndPreloadImage imgUrl={node.image ? node.image.url : ''} alt="最新のセミナー画像" />
                  </div>
                  <SeminarTypes types={node.types} />
                  <div className="seminar_title">{node.title}</div>
                </Link>
                <div className="data">開催日程：{node.display_event_date}</div>
                <div className="seminar_tag">
                  {node.tags.map((tag) => (
                    tag.type[0] === "セミナータグ" ? <p key={tag.id}>#{tag.name}</p> : ''
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>{/* padding_sp スマホのみ隙間 */}
      </div>{/* contents_in */}
    </div>
  )
}

export default SeminarArea
